export enum ENUM_FilterDateRangeActionType {
  UPDATEDATES = "updateDates",
  FILTERDATES = "filterDates",
}

export interface filterDateRangeReducerState {
  filterDates: Date[];
  formatedFilterDates?: { startDate?: string; endDate?: string };
}

export interface filterDateRangeReducerAction {
  type: ENUM_FilterDateRangeActionType;
  payload: Date[];
}
